import apiClient from "./axios"

// Get all customer companies with optional filtering
export const getCustomerCompanies = async (params = {}) => {
  const { data } = await apiClient.get("/customer-companies", { params })
  return data
}

// Get a specific customer company by ID
export const getCustomerCompany = async id => {
  const { data } = await apiClient.get(`/customer-companies/${id}`)
  return data
}

// Create a new customer company
export const createCustomerCompany = async companyData => {
  const { data } = await apiClient.post("/customer-companies", companyData)
  return data
}

// Update an existing customer company
export const editCustomerCompany = async ({ id, ...companyData }) => {
  const { data } = await apiClient.patch(`/customer-companies/${id}`, companyData)
  return data
}

// Delete a customer company (soft delete)
export const deleteCustomerCompany = async id => {
  const { data } = await apiClient.delete(`/customer-companies/${id}`)
  return data
}

// Get all customer companies without pagination
export const getAllCustomerCompanies = async (params = {}) => {
  const { data } = await apiClient.get("/customer-companies", {
    params: { ...params, all: true },
  })
  return data
}

// Search customer companies by name or slug
export const searchCustomerCompanies = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/customer-companies", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// Get trashed customer companies
export const getTrashedCustomerCompanies = async (params = {}) => {
  const { data } = await apiClient.get("/customer-companies/trashed", { params })
  return data
}

// Get a customer company by slug
export const getCustomerCompanyBySlug = async slug => {
  const { data } = await apiClient.get(`/customer-companies/slug/${slug}`)
  return data
}

// Restore a trashed customer company
export const restoreCustomerCompany = async id => {
  const { data } = await apiClient.post(`/customer-companies/${id}/restore`)
  return data
}
